import React from "react";
// react-bootstrap components
import { Card, Form } from "react-bootstrap";
// custom components
import Input from "inputs/input";
// fiche de chantier utils
import { computeDefaultDateCmd, pickInterventionFieldsFromParams } from "interventions/accordions/ficheChantier/utils";

class FicheChantierAccordion extends React.Component {
  constructor(props) {
    super(props);

    // valeurs champs fiche chantier des paramètres (limitées aux champs intervention)
    const defaults = pickInterventionFieldsFromParams(props.data.ficheChantier);

    // valeurs champs fiche chantier de l'intervention
    const interventionFiche = props.create.intervention.ficheChantier || {};

    // merge : les overrides de l'intervention priment sur les paramètres
    const initialFormData = {
      ...defaults,
      ...interventionFiche,
    };

    // Si dateCmd vide (création ou intervention historique sans fiche), pré-remplir
    const dateCmdTouched = !!interventionFiche.dateCmd;
    if (!dateCmdTouched) {
      initialFormData.dateCmd = computeDefaultDateCmd(
        initialFormData.origineCmd,
        props.create.intervention.date,
        props.data.ficheChantier.dateSignContrat
      );
    }

    this.state = {
      formData: initialFormData,
      dateCmdTouched: dateCmdTouched,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleReactSelectChange = this.handleReactSelectChange.bind(this);
  }

  componentDidMount() {
    // Garantir que intervention.ficheChantier est rempli avec les paramètres + pré-remplissage,
    // même si l'utilisateur n'ouvre/ne modifie aucun champ avant d'enregistrer.
    this.props.create.setIntervention({
      ...this.props.create.intervention,
      ficheChantier: this.state.formData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.dateCmdTouched) return;

    const prevOrigineId =
      Array.isArray(prevState.formData.origineCmd) && prevState.formData.origineCmd[0]
        ? prevState.formData.origineCmd[0].id
        : null;
    const currentOrigineId =
      Array.isArray(this.state.formData.origineCmd) && this.state.formData.origineCmd[0]
        ? this.state.formData.origineCmd[0].id
        : null;
    const prevDate = prevProps.create.intervention.date;
    const currentDate = this.props.create.intervention.date;
    const prevDateSign = prevProps.data.ficheChantier.dateSignContrat;
    const currentDateSign = this.props.data.ficheChantier.dateSignContrat;

    if (
      prevOrigineId !== currentOrigineId ||
      prevDate !== currentDate ||
      prevDateSign !== currentDateSign
    ) {
      const newDateCmd = computeDefaultDateCmd(
        this.state.formData.origineCmd,
        currentDate,
        currentDateSign
      );
      if (newDateCmd !== this.state.formData.dateCmd) {
        this.setState(
          (state) => ({
            formData: { ...state.formData, dateCmd: newDateCmd },
          }),
          () => {
            this.props.create.setIntervention({
              ...this.props.create.intervention,
              ficheChantier: this.state.formData,
            });
          }
        );
      }
    }
  }

  handleChange(e) {
    const target = e.target;
    const type = target.type;
    let value = target.value;
    const name = target.name;

    this.setState(
      (state) => {
        let newValue = value;
        if (type === "radio") {
          newValue = Number(value);
        }
        const newFormData = { ...state.formData, [name]: newValue };
        const newDateCmdTouched = name === "dateCmd" ? true : state.dateCmdTouched;
        return { formData: newFormData, dateCmdTouched: newDateCmdTouched };
      },
      () => {
        this.props.create.setIntervention({
          ...this.props.create.intervention,
          ficheChantier: this.state.formData,
        });
      }
    );
  }

  handleReactSelectChange(name, option) {
    this.setState(
      (state) => ({
        formData: { ...state.formData, [name]: [option] },
      }),
      () => {
        this.props.create.setIntervention({
          ...this.props.create.intervention,
          ficheChantier: this.state.formData,
        });
      }
    );
  }

  render() {
    const { formData } = this.state;

    const sections = [
      {
        id: 1002,
        title: "Commande",
        inputGroups: [
          {
            fields: [
              {
                type: "react-select",
                label: "Origine de la commande",
                name: "origineCmd",
                options: [
                  { id: 1, label: "Oral" },
                  { id: 2, label: "Contrat" },
                  { id: 3, label: "Texto" },
                  { id: 4, label: "Mail" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
              {
                type: "date",
                label: "Date de commande",
                name: "dateCmd",
              },
            ],
          },
        ],
      },
      {
        id: 1003,
        title: "Réalisation",
        inputGroups: [
          {
            fields: [
              {
                type: "text",
                label: "Matériel à utiliser",
                name: "materielInterv",
              },
              {
                type: "text",
                label: "Spécificités du chantier",
                name: "specichantier",
              },
              {
                type: "radio",
                label: "Si produits fournis par le client : Conformités des produits avec la commande",
                name: "confPrdClient",
                options: [
                  { id: 1, label: "Oui" },
                  { id: 2, label: "Non" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 1004,
        title: "Après l'application",
        inputGroups: [
          {
            fields: [
              {
                type: "radio",
                label: "Zones à traiter respectées",
                name: "zoneTrait",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
              },
              {
                type: "radio",
                label: "Doses et produits respectés",
                name: "dosePrdResp",
                options: [
                  { id: 1, label: "Oui" },
                  { id: 2, label: "Non" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
              {
                type: "radio",
                label: "Consignes d'exécution respectées",
                name: "consiResp",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
              },
              {
                type: "radio",
                label: "Incidents ou imprévus survenus",
                name: "incident",
                  options: [
                    { id: 1, label: "Oui" },
                    { id: 2, label: "Non" },
                    { id: 0, label: "Indéterminé" },
                  ],
              },
              {
                type: "react-select",
                label: "Gestion des effluents par l'entreprise",
                name: "gestEffluent",
                options: [
                  { id: 1, label: "Oui au champ" },
                  { id: 2, label: "Oui à la ferme" },
                  { id: 3, label: "Non" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
              {
                type: "radio",
                label: "Gestion des EVPP par le client",
                name: "gestEvppClient",
                options: [
                  { id: 1, label: "Oui" },
                  { id: 2, label: "Non" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
            ],
          },
        ],
      },
      {
        id: 1005,
        title: "Consignes de sécurité",
        inputGroups: [
          {
            fields: [
              {
                type: "radio",
                label: "Respect de la ZNT",
                name: "respectZnt",
                options: [
                  { id: 1, label: "Oui" },
                  { id: 2, label: "Non" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
              {
                type: "radio",
                label: "Respect du DVP (dispositif végétalisé permanent) de 5 ou 20 m",
                name: "respectDvp",
                options: [
                  { id: 1, label: "Oui" },
                  { id: 2, label: "Non" },
                  { id: 0, label: "Indéterminé" },
                ],
              },
            ],
          },
        ],
      },
    ];

    // Ajouter le champ intervPoss dans la section Réalisation (avant la logique des precisionFields)
    const realisationSection = sections.find(s => s.id === 1003);
    if (realisationSection) {
      realisationSection.inputGroups[0].fields.push({
        type: "radio",
        label: "En arrivant sur site : Interventions possibles selon le descriptif ci-dessus",
        name: "intervPoss",
        options: [
          { id: 1, label: "Oui" },
          { id: 2, label: "Non" },
          { id: 0, label: "Indéterminé" },
        ],
      });
    }

    // Ajouter les champs de précision conditionnellement
    const precisionFields = [
      { after: "confPrdClient", field: { type: "textarea", label: "Si non-conformités avec la commande des produits fournis par le client, précision", name: "confPrdClientPrec" }, condition: 2 }, // Non
      { after: "intervPoss", field: { type: "textarea", label: "Si interventions impossibles selon le descriptif ci-dessus, précision", name: "intervPossPrec" }, condition: 2 }, // Non
      { after: "zoneTrait", field: { type: "textarea", label: "Si zones à traiter non respectées, précision", name: "zoneTraitPrec" }, condition: 2 }, // Non
      { after: "dosePrdResp", field: { type: "textarea", label: "Si doses et produits non respectés, précision des doses réelles", name: "dosePrdRespPrec" }, condition: 2 }, // Non
      { after: "consiResp", field: { type: "textarea", label: "Si consignes d'exécution non respectées, précision", name: "consiRespPrec" }, condition: 2 }, // Non
      { after: "incident", field: { type: "textarea", label: "Si incidents ou imprévus survenus, précision", name: "incidentPrec" }, condition: 1 }, // Oui
      { after: "respectZnt", field: { type: "textarea", label: "Si non respect de ZNT, précision", name: "respectZntPrec" }, condition: 2 }, // Non
      { after: "respectDvp", field: { type: "textarea", label: "Si non respect du DVP, précision", name: "respectDvpPrec" }, condition: 2 }, // Non
    ];

    // Insérer les champs de précision dans les sections
    sections.forEach(section => {
      section.inputGroups.forEach(group => {
        const newFields = [];
        group.fields.forEach(field => {
          newFields.push(field);
          // Chercher si ce champ a un champ de précision associé
          const precField = precisionFields.find(p => p.after === field.name);
          if (precField && formData[field.name] === precField.condition) {
            newFields.push(precField.field);
          }
        });
        group.fields = newFields;
      });
    });

    return (
      <div className="w-100 mt-3">
        {sections.map((section, sectionIndex) => (
          <Card key={sectionIndex} text="dark" className="mb-3">
            <Card.Header as="h5">{section.title}</Card.Header>
            <Card.Body>
              {section.inputGroups.map((inputGroup, groupIndex) => (
                <div key={groupIndex}>
                  <h6 className="mb-3">{inputGroup.name}</h6>
                  <Form>
                    {inputGroup.fields.map((input, inputIndex) => {
                      let options = input.options || [];
                      // Dans le formulaire d'intervention, ne pas afficher l'option "Indéterminé" (id = 0)
                      // Sauf pour les champs origineCmd et gestEffluent où on doit afficher "Indéterminé"
                      if (
                        (input.type === "radio" || input.type === "react-select") &&
                        Array.isArray(options) &&
                        input.name !== "origineCmd" &&
                        input.name !== "gestEffluent"
                      ) {
                        options = options.filter((option) => option.id !== 0);
                      }
                      return (
                        <Input
                          key={inputIndex}
                          input={input}
                          value={formData[input.name]}
                          options={options}
                          handleChange={this.handleChange}
                          handleReactSelectChange={this.handleReactSelectChange}
                          gridSize={{ label: "6", input: "6" }}
                        />
                      );
                    })}
                  </Form>
                </div>
              ))}
            </Card.Body>
          </Card>
        ))}
      </div>
    );
  }
}

export default FicheChantierAccordion;

